import clsx from "clsx"

import styles from "./SkeletonTypography.module.scss"
import type { SkeletonTypographyProps } from "./SkeletonTypography.types"

export default function SkeletonTypography(props: SkeletonTypographyProps) {
    const { variant, className } = props

    return (
        <div className={clsx(styles.base, styles[variant], className)}>
            <div className={styles.bar} />
        </div>
    )
}
